import script from "./GalleryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryCard.vue?vue&type=script&setup=true&lang=js"

import "./GalleryCard.vue?vue&type=style&index=0&id=7c6abcca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6abcca"]])

export default __exports__